import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import HeaderContent from './HeaderContent';
import { Button, Modal, Select, Radio, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { updatePage } from '../ApphomeActions';
import { UpOutlined } from '@ant-design/icons';
const CheckinsContent = (props) => {
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const { apphome } = props;
  const dispatch = useDispatch();
  const [showCustomizeDataModal, setShowCustomizeDataModal] = useState(false);
  const handleCustomize = () => {
    setShowCustomizeDataModal(true);
  };
  const [showCheckinsWhere, setShowCheckinsWhere] =
    useState('adminorparticipant');
  const handleOk = () => {
    try {
      const data = {
        customizeConfiguration: {
          showCheckinsWhere,
        },
      };
      dispatch(
        updatePage(props.match.params.wId, apphome._id, apphome.pageView, data)
      );
      setShowCustomizeDataModal(false);
    } catch (error) {
      console.error(error);
      setShowCustomizeDataModal(false);
    }
  };
  useEffect(() => {
    const page =
      apphome && apphome.pages.find((page) => page._id === apphome.pageView);
    const customizeConfiguration = page && page.customizeConfiguration;
    if (customizeConfiguration && customizeConfiguration.showCheckinsWhere) {
      setShowCheckinsWhere(customizeConfiguration.showCheckinsWhere);
    }
  }, [apphome]);
  return (
    <div>
      {showCustomizeDataModal && (
        <Modal
          width={600}
          title='Customize data'
          okText='Save'
          visible={true}
          onOk={handleOk}
          onCancel={() => setShowCustomizeDataModal(false)}
        >
          <div style={{ display: 'flex', margin: '16px', gap: '32px' }}>
            <div>Show Checkins where</div>

            <Radio.Group
              onChange={(event) => setShowCheckinsWhere(event.target.value)}
              value={showCheckinsWhere}
            >
              <Space direction='vertical'>
                <Radio value='participant'>I'm a participant</Radio>
                <Radio value='admin'>I'm an administrator</Radio>
                <Radio value='adminorparticipant'>
                  Administrator or Participant
                </Radio>
              </Space>
            </Radio.Group>
          </div>
        </Modal>
      )}
      <HeaderContent
        title='My Checkins'
        buttonName='Customize data'
        buttonType='common'
        handleCustomize={handleCustomize}
        hideCustomizeButtons={props.hideCustomizeButtons}
      />
      <div
        style={{
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <div style={{ fontSize: '16px', color: '#1264A3' }}>
              Daily Standup
            </div>
            <div
              style={{
                background: '#F1F1F1',
                border: '0.5px solid #A8A8A8',
                borderRadius: '1px',
                padding: '2px 4px 2px 4px',
                fontSize: '14px',
                color: '#E01E5A',
              }}
            >
              In 2 hours
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          fontSize: '16px',
          color: `${!isDarkTheme ? 'rgba(0, 0, 0, 0.85)' : ''}`,
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        Reporting to 1 member after every submission
      </div>
      <div
        style={{
          color: `${!isDarkTheme ? 'rgba(0, 0, 0, 0.45)' : ''}`,
          fontSize: '14px',
          textAlign: 'center',
          width: '144px',
          padding: '4px 15px 4px 15px',
          borderRadius: '4px',
          border: '1px solid #D9D9D9',
          boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.016)',
        }}
      >
        Other action &nbsp;&nbsp;&nbsp;
        <UpOutlined />
      </div>
    </div>
  );
};

export default withRouter(CheckinsContent);
